// import axios from "axios/dist/axios";
import Cookies from "js-cookie";
import { Toast } from "vant";
import jsbridge from "@/utils/jsbridge";
import * as webtrackbrowser from "@/utils/web-track-browser";

const interceptorHandler = (instance) => {
  instance.interceptors.request.use(
    (config) => {
      config.headers["auth-key"] = "ae4f45270580686319de743d4595d7c1";
      config.headers["device-uid"] = Cookies.get("device-uid");
      config.headers["app-ver"] = Cookies.get("versionCode") || 31400;
      config.headers["from"] = "activity";

      // config.headers["app-ver"] = Cookies.get("versionCode") || 31400;
      // config.headers["app-ver"] = 31400;
      // config.headers["from"] = 'activity';

      config.headers["device-id"] =
        Cookies.get("deviceId") || Cookies.get("XJUID");
      config.headers["chn"] = Cookies.get("channel");
      config.headers.Authorization = Cookies.get("token");
      if (
        process.env.NODE_ENV !== "development" &&
        config.params?.useAppToken
      ) {
        config.headers["protect-platform"] = jsbridge.isIOS()
          ? "iOS"
          : "Android";
      }
      config.headers["user-device-type"] = jsbridge.isIOS() ? "iOS" : "Android";
      return config;
    },
    (err) => {
      if (typeof window === "object") {
        // Toast(err);
      }

      return Promise.reject(err);
    }
  );

  instance.interceptors.response.use(
    // @ts-ignore
    async (res) => {
      const { data, config, headers } = res;
      if (headers["need-token"] || headers["need-protect"]) {
        const { versionCode } = jsbridge.getSystemInfo();
        // const { id } = jsbridge.getNativeUserInfo();
        // console.log(config);
        let token = "";

        if (!config.params?.useAppToken) {
          if (headers["need-token"]) {
            token = await new Promise((_resolve) => {
              window.wm?.getToken("8f817041139d4044a1e5f0b4d2dcb9e1", _resolve);
            });
          } else {
            const negRes = await window.neg.getToken();
            if (negRes.code === 200) {
              token = negRes.token;
            }
          }
        } else {
          if (Number(versionCode) < 23600) {
            Toast("请升级版本");
            return Promise.reject("请升级版本");
          }

          token = await new Promise((resolve) => {
            if (process.env.NODE_ENV === "development") {
              if (headers["need-token"]) {
                console.log("need-token-------->");
                window.wm?.getToken(
                  "8f817041139d4044a1e5f0b4d2dcb9e1",
                  resolve
                );
              } else {
                window.neg.getToken().then((negRes) => {
                  console.log("negRes ------>", negRes);
                  if (negRes.code === 200) {
                    resolve(negRes.token);
                  }
                });
              }

              return;
            }
            // APP内嵌活动页面需要调APP内置方法获取 token
            const time = Date.now().toString();
            console.log("获取token", time);

            if (Number(versionCode) < 30700) {
              window.getYDTokenSuccess = (token, t) => {
                console.log("token 获取成功", { token, t });

                if (time == t) {
                  resolve(token);
                }
              };

              jsbridge.jsBridge("getYDToken", time);
            } else {
              window.getYDHTProtectSuccess = (businessId, code, token) => {
                console.log("token 获取成功", {
                  token,
                  businessId,
                  hbid: headers["ir-business-id"],
                  code,
                });

                if (
                  businessId == headers["ir-business-id"] &&
                  Number(code) === 200
                ) {
                  resolve(token);
                }
              };

              jsbridge.jsBridge("getYDHTProtect", headers["ir-business-id"]);
            }
          });
        }

        if (headers["need-token"]) {
          config.headers["device-token"] = token;
        } else {
          config.headers["protect-token"] = token;
        }

        return instance.request(config);
      }

      if (data === null) {
        return { data };
      }
      if (data.r === undefined) {
        return { data };
      }

      if (Number(data.r) !== 0) {
        Toast(data?.msg || data?.message);
        return Promise.reject(data.msg || data?.message);
      }
      return data;
    },
    (err) => {
      const { status, data } = err.response;
      if (status === 401) {
        if (!jsbridge.isWebview()) {
          Toast("登录已过期");
          Cookies.remove("token");
          Cookies.remove("authInfo");
          setTimeout(() => {
            location.href = `${
              location.origin
            }/xj-web/h5/login?redirectUrl=${encodeURIComponent(location.href)}`;
          }, 500);
        } else {
          Toast("登录已过期");
        }

        // return Promise.reject(new Error("登录已过期"));
      } else {
        Toast(data?.msg || data?.message);
      }

      webtrackbrowser.sendInfo(err, {});

      return Promise.reject(err);
    }
  );
  return instance;
};

export const gameRequest = interceptorHandler(
  axios.create({
    baseURL: process.env.VUE_APP_GAME_API_HOST,
  })
);

export default interceptorHandler(
  axios.create({
    baseURL: process.env.VUE_APP_API_HOST,
  })
);
